module.exports = __webpack_public_path__ + "html/pricing-sticker-form.template.html";